import { ProcesName } from './ProcesHandlerHelpers';
import { ProcesHandler } from '../../interfaces/FormConfig';
import { ReactFormHelpers } from './FormHelpers';
import { FormProps, FormState } from '../FormContainer';
import { IntakeService } from "../../services/IntakeService";

export class GespreksRegistratieProcessHandlerHelpers {
    static getProcesses(): ProcesHandler[] {
        return [
            
            {
                // PUT when done
                procesName: ProcesName.Put_postprocess_Success,
                execute: (
                    component: React.Component<FormProps, FormState>,
                    data: any,
                    onSuccess,
                    onError
                ) => {
                  const formData = ReactFormHelpers.collectDataFromForms(component as any); 
                  IntakeService.setAnswer(formData["Antwoord"]);
                  IntakeService.setQuestion(formData["Vraag"]);
                  onSuccess(data);                                                                          
                }
            }
        ];
    }
}
